import { useEffect, useState } from 'react';

import { PHONE_MAX, applyPhoneFlag, isPhone } from './detect';

export function usePhone(): boolean {
  const [on, setOn] = useState(() => isPhone());
  useEffect(() => {
    const tick = (): void => {
      applyPhoneFlag();
      setOn(isPhone());
    };
    tick();
    const coarse = window.matchMedia?.('(pointer: coarse)');
    const narrow = window.matchMedia?.(`(max-width: ${PHONE_MAX}px)`);
    coarse?.addEventListener?.('change', tick);
    narrow?.addEventListener?.('change', tick);
    window.addEventListener('resize', tick);
    return () => {
      coarse?.removeEventListener?.('change', tick);
      narrow?.removeEventListener?.('change', tick);
      window.removeEventListener('resize', tick);
    };
  }, []);
  return on;
}
